import api from 'api';
import {
  NOTIFICATION_TYPE,
  NOTIFICATION_TYPE_CODE,
  NotificationType,
} from 'models/Notification';

export const getNotificationRedirectionDynamicPath = (
  notification: NotificationType,
): (() => Promise<string>) | null => {
  const { typeCode, content } = notification;

  // Old notification has direct link to envelopeTemplateUrl
  if (content.envelopeTemplateUrl) {
    return undefined;
  }

  try {
    switch (typeCode) {
      case NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.SENT_NDA]:
      case NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.SIGNED_NDA]: {
        const { envelopeId, leadId } = content || {};

        if (!envelopeId || !leadId) {
          throw new Error('Missing params for viewNda');
        }

        return async () => {
          const { data } = await api.portfolio.seller.viewNda(
            leadId,
            envelopeId,
          );
          return data.url;
        };
      }
      default:
        return null;
    }
  } catch (error) {
    return;
  }
};
